import PropTypes from 'prop-types';

const ProcessStep = ({ number, title, description, icon: Icon, isLast = false }) => {
  return (
    <div
      className="process-step"
      data-aos="fade-up"
      data-aos-delay={number * 100}
    >
      <div className="process-number">
        <span className="process-number-text">{number}</span>
        <Icon className="process-icon" />
      </div>
      {!isLast && <div className="process-connector" />}
      <div className="process-content">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
};

ProcessStep.propTypes = {
  number: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  isLast: PropTypes.bool,
};

export default ProcessStep;
